import styled, { css } from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { mediaWideNavless } from '@xing-com/layout-tokens';

import { useAdRefresh } from '../../hooks';

import { DisplayAdLogoutHalfpage01 } from './halfpage-ad-01';
import { DisplayAdLogoutHalfpage02 } from './halfpage-ad-02';

const AdContainerBase = css`
  position: absolute;
  min-width: 120px;
  max-width: 300px;
  height: 600px;
  z-index: 1;
  top: 54px;

  @media ${mediaWideNavless} {
    top: 85px;
  }
`;

const AdContainerLeft = styled.div`
  ${AdContainerBase}
  left: 0;
`;

const AdContainerRight = styled.div`
  ${AdContainerBase}
  right: 0;
`;

export const DisplayAdLogoutHalfpageSlot: React.FC = () => {
  const isWideSize = useMatchMedia(mediaWideNavless);

  const { refreshDesktop } = useAdRefresh({
    isSmallScreen: !isWideSize,
    slots: {
      mobile: '',
      desktop: 'halfpage',
    },
  });

  if (!isWideSize) {
    return null;
  }

  return (
    <NoSSR>
      <AdContainerLeft>
        <DisplayAdLogoutHalfpage01 refresh={refreshDesktop} />
      </AdContainerLeft>
      <AdContainerRight>
        <DisplayAdLogoutHalfpage02 refresh={refreshDesktop} />
      </AdContainerRight>
    </NoSSR>
  );
};
